import { BOARD_COLUMNS } from "@/utils/deals.utils";
import { Card, CardContent, CardFooter, CardHeader } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";

function DealCardSkeleton() {
  return (
    <Card className="min-h-52 border-dash-border shadow-none">
      <CardHeader className="gap-1.5 p-5 pb-3">
        <div className="flex items-start justify-between gap-2">
          <Skeleton className="h-5 w-3/5" />
          <Skeleton className="mt-0.5 h-5 w-16 rounded-full" />
        </div>
        <Skeleton className="h-4 w-2/5" />
      </CardHeader>
      <CardContent className="flex flex-col gap-3 px-5 pb-4">
        <div className="flex items-center gap-3">
          <Skeleton className="h-1.5 flex-1 rounded-full" />
          <Skeleton className="h-3 w-8" />
        </div>
        <Skeleton className="h-4 w-28" />
      </CardContent>
      <CardFooter className="flex-col items-stretch gap-3 border-t border-dash-border px-5 py-4">
        <Skeleton className="h-6 w-24" />
        <div className="flex items-center gap-2">
          <Skeleton className="size-6 rounded-full" />
          <Skeleton className="h-4 w-24" />
        </div>
      </CardFooter>
    </Card>
  );
}

export default function DealBoardSkeleton() {
  return (
    <div className="grid gap-5 md:grid-cols-2 xl:grid-cols-4" aria-label="Loading deals" role="status">
      {BOARD_COLUMNS.map((column) => (
        <div key={column.id} className="min-w-0">
          <div className="mb-4 flex items-center gap-2">
            <Skeleton className="h-4 w-24" />
            <Skeleton className="size-[19px] rounded-full" />
          </div>
          <div className="flex flex-col gap-3">
            <DealCardSkeleton />
            <DealCardSkeleton />
          </div>
        </div>
      ))}
      <span className="sr-only">Loading deal cards…</span>
    </div>
  );
}
